import { render } from "./ResidentPass.vue?vue&type=template&id=bafa61bc&scoped=true"
import script from "./ResidentPass.vue?vue&type=script&lang=js"
export * from "./ResidentPass.vue?vue&type=script&lang=js"

import "./ResidentPass.vue?vue&type=style&index=0&id=bafa61bc&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafa61bc"],['__file',"src/assets/js/pages/AddGate/ResidentPass.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bafa61bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bafa61bc', __exports__)) {
    api.reload('bafa61bc', __exports__)
  }
  
  module.hot.accept("./ResidentPass.vue?vue&type=template&id=bafa61bc&scoped=true", () => {
    api.rerender('bafa61bc', render)
  })

}


export default __exports__